import { render, staticRenderFns } from "./LocationRemarks.vue?vue&type=template&id=7cc87d12"
import script from "./LocationRemarks.vue?vue&type=script&lang=js"
export * from "./LocationRemarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports